import { render, staticRenderFns } from "./EditChangePwdDialog.vue?vue&type=template&id=d2de57a2&"
import script from "./EditChangePwdDialog.vue?vue&type=script&lang=ts&"
export * from "./EditChangePwdDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports